export * from './UiWindowNewUpRightIcon';
export * from './UiWindowNewUpRightIcon16Light';
export * from './UiWindowNewUpRightIcon16Regular';
export * from './UiWindowNewUpRightIcon16Solid';
export * from './UiWindowNewUpRightIcon20Light';
export * from './UiWindowNewUpRightIcon20Regular';
export * from './UiWindowNewUpRightIcon20Solid';
export * from './UiWindowNewUpRightIcon24Regular';
export * from './UiWindowNewUpRightIcon24Solid';
export * from './UiWindowNewUpRightIcon32Regular';
export * from './UiWindowNewUpRightIcon64Regular';
